<template>
  <b-row
    :class="customChange ? 'list-group-item' : ''"
  >
    <b-col
      sm="12"
      md="12"
      lg="12"
    >
      <b-overlay
        id="overlay-background-documents"
        :show="statementLoader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-card
          :id="`debt-statements`"
        >
          <b-card-header
            class="base-document-header"
          >
            <b-card-title>{{ $t('DEBTIA_STATEMENTS') }}</b-card-title>
            <b-card-title class="text-primary">
              <!-- <drag-links
                :parent="1"
                :side="side"
                :custom-change="customChange"
              /> -->
            </b-card-title>
            <b-card-title
              v-if="$ability.can(constants.action.permissionEditStatements, constants.resource.user)"
              class="text-primary"
            >
              <b-button
                id="edit-statements"
                v-b-modal.modal-edit-statements
                variant="primary"
                @click="changeBtn()"
              >
                <span class="text-nowrap">{{ $t('DEBTIA_CHANGE_STATEMENT') }}</span>
              </b-button>
            </b-card-title>
          </b-card-header>
          <b-table
            :fields="statementsTableFields"
            :items="statements"
            striped
            responsive
            table-class="parent-table"
          >
            <template #cell(category)="row">
              <b-link
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              >
                {{ ($i18n.locale === 'en') ? row.item.en_name : row.item.da_name }}
              </b-link>
            </template>
            <template #cell(totalAmount)="row">
              {{ formatCurrency(row.item.totalAmount) }}
            </template>
            <template #cell(paidAmount)="row">
              {{ formatCurrency(row.item.paidAmount) }}
            </template>
            <template #cell(restAmount)="row">
              {{ formatCurrency(row.item.restAmount) }}
            </template>
          </b-table>
        </b-card>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BLink, BTable, BCardHeader, BCardTitle, BButton, BOverlay,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import constants from '@/app-configs/constants'
import axios from '@axios'
import i18n from '@/libs/i18n'
// import DragLinks from '../DragLinks.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BLink,
    BTable,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    // DragLinks,
    BCardHeader,
    BCardTitle,
    BButton,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  props: {
    side: {
      type: String,
      required: true,
    },
    customChange: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      statementLoader: false,
      statementsData: [],
      defaultCurrency: 'DKK',
      constants,
      caseId: this.$route.params.id,
      statements: [],
      showBailifCheckbox: true,
      bailifValue: true,
      disableBailif: true,
      editStatementModalClicked: false,
    }
  },
  computed: {
    statementsTableFields() {
      return [
        { key: 'category', label: '', tdClass: 'text-left' },
        { key: 'totalAmount', label: i18n.t('DEBTIA_TOTAL_AMOUNT'), tdClass: 'text-right' },
        { key: 'paidAmount', label: i18n.t('DEBTIA_PAID_AMOUNT'), tdClass: 'text-right' },
        { key: 'restAmount', label: i18n.t('DEBTIA_REST_AMOUNT'), tdClass: 'text-right' },
      ]
    },
  },
  created() {
    this.getStatements()
  },
  methods: {
    changeBtn() {
      this.editStatementModalClicked = !this.editStatementModalClicked
    },
    getEntries(data) {
      const arr = []
      Object.entries(data).forEach(value => {
        arr.push(value[1])
      })
      return arr
    },
    formatCurrency(amount) {
      const formattedAmnt = new Intl.NumberFormat('da-DK', { style: 'currency', currency: this.defaultCurrency }).format(parseFloat(amount).toFixed(2))
      return formattedAmnt
    },
    async openLink(href) {
      window.open(href, '_blank')
    },
    async getStatements() {
      this.statementLoader = true
      const url = `/debt-case/statements/${this.caseId}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.statementLoader = false
          this.statements = response.data.data.statements
        }
      })
    },
  },
}
</script>

<style lang="scss">
</style>
